import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppInjector } from './app/app-injector.service';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { installCopyTrim } from './app/core/copy-trim';
import { installAdaptiveSubmenuPositioning } from './app/core/mat-menu/adaptive-submenu-position';
import { LogService } from './app/services/log-service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

installAdaptiveSubmenuPositioning();
installCopyTrim();

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] })
  .then((appRef) => {
    AppInjector.setInjector(appRef.injector);
  })
  .catch((err) => {
    LogService.error(this, 'bootstrapApplication', LogService.ERROR, err);
  });
